export const END_POINTS = {
  API_CLIENT: 'api-clients',
  COUNTRY: 'country',
  COUNTRY_LIMITATION: 'country-limitation',
  ORGANIZATION_LIMITATION: 'organization-limitation',
  REGION_LIMITATION: 'region-limitation',
  REGION_LIMITATIONS: 'region-limitations-by-user-country',
  PROVINCE_LIMITATION: 'province-limitation',
  REGION: 'regions',
  REGION_BY_AUTH_COUNTRY: 'regions/by-auth-country',
  REGION_BY_REGIONAL_ADMIN: 'regions/by-regional-admin',
  PROVINCE: 'provinces',
  PROVINCE_BY_REGION: 'provinces-by-user-region',
  PHC_SERVICES: 'phc-services',
  PROVINCES_LIMITATION: 'provinces-limitation',
  COUNT_THERAPIST_BY_CLINIC: 'clinic/therapist/count/by-clinic',
  CLINIC: 'clinic',
  CLINIC_BY_PROVINCE: 'clinic-by-province',
  PROFESSIONS: 'profession',
  PROFESSION_LIST: 'profession/list',
  PHC_SERVICES_BY_PROVINCE: 'phc-services-by-province',
  PHC_SERVICES_OPTION_LIST: 'phc-services/option/list',
  ADMIN: 'admin',
  ADMIN_UPDATE_STATUS: 'admin/updateStatus',
  ADMIN_RESEND_EMAIL: 'admin/resend-email',
  PHC_WORKERS: 'phc-workers',
  COUNT_PHC_WORKER_BY_PHC_SERVICE: 'phc-services/count-phc-worker',
  PHC_WORKERS_UPDATE_STATUS: 'phc-workers/updateStatus',
  PHC_WORKERS_RESEND_EMAIL: 'phc-workers/resend-email',
  PHC_WORKERS_DELETE: 'phc-workers/delete/by-id',
  PHC_WORKER_LIST_BY_PHC_SERVICE: 'phc-workers/list/by-phc-service',
  PATIENT_REFERRAL: 'patient-referrals',
  INTERVIEW_HISTORY: 'screening-questionnaires-history-by-patient-list',
  THERAPIST_BY_CLINIC: 'therapist/list/by-clinic-id',
  PATIENT_REFERRAL_ASSIGNMENT: 'patient-referral-assignments',
  PATIENT_LIST_BY_PHC_WORKER_IDS: 'patient/list/by-phc-worker-ids',
  GUIDANCE_PAGE: 'guidance-page',
  GUIDANCE_PAGE_UPDATE_ORDER: 'guidance-page/update-order',
  TRANSLATOR: 'translator',
  NUMBER_OF_TRANSFER_BY_THERAPIST: 'transfer/number/by-therapist',
  PATIENT_LIST_FOR_PHC_WORKER_REMOVE: 'patient/list/for-phc-worker-remove',
  EMAIL_TEMPLATE: 'email-templates',
  MFA_SETTING: 'mfa-settings',
  AUDIT_LOG: 'audit-logs',
  THERAPIST_AUDIT_LOG: 'therapist-audit-logs',
  PATIENT_AUDIT_LOG: 'patient-audit-logs',
};
